"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var calculateDuration = function calculateDuration(eventTime) {
  return _moment["default"].duration(Math.max(eventTime - Math.floor(Date.now() / 1000), 0), 'seconds');
};

function Countdown(_ref) {
  var eventTime = _ref.eventTime,
      interval = _ref.interval,
      finished = _ref.finished,
      label = _ref.label,
      size = _ref.size,
      locator = _ref.locator;

  var _useState = (0, _react.useState)(calculateDuration(eventTime)),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      duration = _useState2[0],
      setDuration = _useState2[1];

  var timerRef = (0, _react.useRef)(0);
  var timerCallback = (0, _react.useCallback)(function () {
    setDuration(calculateDuration(eventTime));
  }, [eventTime]);
  (0, _react.useEffect)(function () {
    if (duration['_milliseconds'] <= 0) {
      finished();
    } else {
      timerRef.current = setInterval(timerCallback, interval);
      return function () {
        clearInterval(timerRef.current);
      };
    }
  }, [eventTime, duration]);
  var minutes = duration.minutes();
  var seconds = duration.seconds();
  var classNames = (0, _classnames["default"])(_defaultModule["default"]['wrapper'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['big'], size === 'big'));
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classNames,
    "data-locator": "timer.".concat(locator)
  }, label, " ", String(minutes).length === 1 ? "0".concat(minutes) : minutes, ":", String(seconds).length === 1 ? "0".concat(seconds) : seconds);
}

var _default = Countdown;
exports["default"] = _default;